import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Select, Option } from '@saucelabs/ds-inputs';

import { GlobalState } from '../reducers';
import {
  actions as testConfigurationActions,
  selectors as testConfigSelectors,
} from '../ducks/testConfiguration';
import NoActiveTunnels from './NoActiveTunnels';

// TODO: remove when our tunnel representation is streamlined and typed
type Tunnel = {
  key: string;
  text: string;
  value: string;
  disabled: boolean;
}

const TunnelSelector: React.FC = () => {
  const dispatch = useDispatch();
  const selectedTunnel = useSelector<GlobalState, string>(testConfigSelectors.tunnelSelector);
  const { tunnelOptions: options } = useSelector<GlobalState, { tunnelOptions: Tunnel[]}>(
    testConfigSelectors.tunnelConfigSelector,
  );
  const defaultSelectedTunnelKey = options.find((tunnel) => (
    tunnel.value === selectedTunnel
  ))?.key ?? options[0]?.key;

  const onChange = (tunnelKey) => {
    dispatch(testConfigurationActions.updateTestConfigValue({
      tunnel: options.find((tunnel) => tunnel.key === tunnelKey)?.value,
    }));
  };

  return (
    <div className="w-full max-w-xl">
      {options.length === 0 && (
        <NoActiveTunnels />
      )}

      {options.length !== 0 && (
        <Select
          aria-label="Tunnel Selection"
          data-qa="test-config-tunnel-selection"
          defaultSelectedKey={defaultSelectedTunnelKey}
          label="Tunnel Proxies"
          name="tunnel"
          onSelectionChange={onChange}
        >
          {options
            // can't disable Options right now, so it's better not to show them
            .filter((tunnel) => !tunnel.disabled)
            .map((tunnel) => (
              <Option
                key={tunnel.key}
                data-qa={`tunnel-${tunnel.text}`}
                disabled={tunnel.disabled}
              >
                {tunnel.text}
              </Option>
            ))}
        </Select>
      )}
    </div>
  );
};

export default TunnelSelector;
